export default "__VITE_ASSET__CufPzIOP__"